// extracted by mini-css-extract-plugin
export default {"pagination":"pagination_pagination__CQQJN","pagination__crumbs":"pagination_pagination__crumbs__57+Uz"};